import { render } from "./Quickpay.vue?vue&type=template&id=6af918f9&scoped=true"
import script from "./Quickpay.vue?vue&type=script&lang=js"
export * from "./Quickpay.vue?vue&type=script&lang=js"

import "./Quickpay.vue?vue&type=style&index=0&id=6af918f9&lang=scss"
import "./Quickpay.vue?vue&type=style&index=1&id=6af918f9&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6af918f9"]])

export default __exports__